import axios from '@/libs/axios';

export const sendLoginSms = (mobile) => {
    return axios.request({
        method: 'post',
        url: 'storage/sms?mobile=' + mobile
    });
};

export const sendResetPasswordSms = (mobile) => {
    return axios.request({
        method: 'post',
        url: 'storage/sms/resetPassword?mobile=' + mobile
    });
};

export const passwordLogin = (mobile, password) => {
    const data = {mobile, password};
    return axios.request({
        data,
        method: 'post',
        url: 'storage/user/login'
    });
};

export const smsLogin = (mobile, code) => {
    const data = {mobile, code};
    return axios.request({
        data,
        method: 'post',
        url: 'storage/user/login'
    });
};

export const wxOAuthLogin = (code) => {
    return axios.request({
        data: code,
        method: 'post',
        url: 'storage/user/wx/auth/login'
    });
};

export const resetPassword = (mobile, password, code) => {
    const data = {mobile, password, code};
    return axios.request({
        data,
        method: 'post',
        url: 'storage/user/password'
    });
};

export const passwordGzBind = (token, mobile, password) => {
    const data = {mobile, password};
    return axios.request({
        data,
        method: 'post',
        url: 'storage/user/gzBind?token=' + token
    });
};

export const smsGzBind = (token, mobile, code) => {
    const data = {mobile, code};
    return axios.request({
        data,
        method: 'post',
        url: 'storage/user/gzBind?token=' + token
    });
};

export const gzUnbind = (token) => {
    return axios.request({
        data: token,
        method: 'post',
        url: 'storage/user/gzUnbind'
    });
};

export const logout = () => {
    return axios.request({
        method: 'POST',
        showLoading: true,
        url: 'storage/user/logout'
    });
};

export const getAds = () => {
    return axios.request({url: 'storage/ad/h5'});
};

export const getNearbyStations = (params) => {
    return axios.request({
        removeToken: true,
        showLoading: true,
        url: 'storage/station/search?distance=6000000&longitude=' + params.longitude + '&latitude=' + params.latitude + (params.keywords ? '&keywords=' + params.keywords : '')
    });
};

export const storeGoods = (keyword, page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/store?keyword=' + keyword + '&page=' + page + '&pageSize=' + pageSize
    });
};

export const scoreGoodExchange = (goodId) => {
    return axios.request({
        method: 'POST',
        showLoading: true,
        url: 'storage/store/goods/' + goodId + '/exchange'
    });
};

export const getActivityList = (page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/activity?page=' + page + '&pageSize=' + pageSize
    });
};

export const myOrders = (keyword, status, page, pageSize) => {
    return axios.request({
        showLoading: status !== 4,
        url: 'storage/order/my?status=' + status + '&keyword=' + keyword + '&page=' + page + '&pageSize=' + pageSize
    });
};

export const getStations = (params) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station',
        params: params
    });
};

export const getStationBaseInfo = (code) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/baseInfo'.format(code)
    });
};

export const getStationCheckItems = (code) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/checkItems'.format(code)
    });
};

export const getStation = (code, returnTimeBucket) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/' + code + '?returnTimeBucket=' + (!!returnTimeBucket)
    });
};

export const getStationGuns = (stationCode) => {
    return axios.request({
        url: 'storage/station/' + stationCode + '/gun'
    });
};

export const createStationRepairRecord = (stationCode, data) => {
    return axios.request({
        method: 'POST',
        url: 'storage/station/{0}/repair'.format(stationCode),
        data: data
    });
};

export const getStationRepairRecord = (stationCode, params) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/repair'.format(stationCode),
        params: params
    });
};

export const getStationRepairRecordDetail = (id) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/repair/{0}'.format(id),
    });
};

export const getStationStockType = () => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/stockType',
    });
};

export const getStationStockNum = (stationCode, type) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/stock/{1}'.format(stationCode, type),
    });
};

export const createStationStockRecord = (stationCode, data) => {
    return axios.request({
        method: 'POST',
        url: 'storage/station/{0}/stock'.format(stationCode),
        data: data
    });
};

export const getStationStockRecord = (stationCode, params) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/stock'.format(stationCode),
        params: params
    });
};

export const getStationStockRecordDetail = (id) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/stock/{0}'.format(id),
    });
};

export const createStationCheckRecord = (stationCode, data) => {
    return axios.request({
        method: 'POST',
        url: 'storage/station/{0}/check'.format(stationCode),
        data: data
    });
};

export const getStationCheckRecord = (stationCode, params) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/{0}/check'.format(stationCode),
        params: params
    });
};

export const getStationCheckRecordDetail = (id) => {
    return axios.request({
        method: 'GET',
        url: 'storage/station/check/{0}'.format(id),
    });
};

export const stopChargeByGunCode = (code) => {
    return axios.request({
        method: 'PUT',
        showLoading: true,
        url: 'storage/gun/' + code + '/stop-charge'
    });
};

export const getCost = (sn) => {
    return axios.request({
        showLoading: true,
        url: 'storage/order/' + sn + '/cost'
    });
};

export const replyState = (pileCode) => {
    return axios.request({
        url: 'storage/pile/' + pileCode + '/reply-state'
    });
};

export const me = () => {
    return axios.request({
        method: 'GET',
        url: 'storage/user/me'
    });
};

export const scanQRCode = (content) => {
    return axios.request({
        data: content,
        method: 'POST',
        showLoading: true,
        url: 'storage/scanQr'
    });
};

export const scanQRCodeCharge = (money, qrContent, subPlatform) => {
    return axios.request({
        method: 'GET',
        url: 'storage/pay/webPay/UMS?type=2&money=' + money + '&qrContent=' + qrContent + '&subPlatform=' + subPlatform
    });
};

export const rechargeTemplate = () => {
    return axios.request({
        url: 'storage/recharge/template'
    });
};

export const recharge = (money, subPlatform) => {
    return axios.request({
        method: 'GET',
        url: 'storage/pay/webPay/UMS?type=1&money=' + money + '&subPlatform=' + subPlatform
    });
};

export const getBalanceRecords = (page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/user/balance/history?page=' + page + "&pageSize=" + pageSize
    });
};

export const scoreExchange = (outSn, kwh) => {
    return axios.request({
        data: kwh,
        method: 'POST',
        showLoading: true,
        url: 'storage/score/order/' + outSn
    });
};

export const scoreChange = (page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/score/my?page=' + page + '&pageSize=' + pageSize
    });
};

export const bindCar = (data) => {
    return axios.request({
        data: data,
        method: 'POST',
        showLoading: true,
        url: 'storage/car/bind'
    });
};

export const referrerGetScore = (mobile) => {
    return axios.request({
        method: 'PUT',
        showLoading: true,
        url: 'storage/score/referrer?mobile=' + mobile
    });
};

export const referrerList = (keyword, page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/score/referrer?keyword=' + keyword + '&page=' + page + '&pageSize=' + pageSize
    });
};

export const getCouponList = (keyword, page, pageSize) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/coupon?keyword=' + keyword + '&page=' + page + '&pageSize=' + pageSize
    });
};

export const couponExchange = (outSn, kwh) => {
    return axios.request({
        data: kwh,
        method: 'POST',
        showLoading: true,
        url: 'storage/coupon/order/' + outSn
    });
};

export const getCouponDetail = (id) => {
    return axios.request({
        method: 'GET',
        showLoading: true,
        url: 'storage/coupon/' + id
    });
};

export const getCarNumberAndOrderSn = (stationCode, carNumber) => {
    return axios.request({
        method: 'GET',
        url: 'storage/user/park?stationCode=' + stationCode + (carNumber ? '&carNumber=' + carNumber : '')
    });
};

export const getParkFee = (stationCode, carNumber, orderSns) => {
    return axios.request({
        method: 'POST',
        data: orderSns,
        url: 'storage/car/park-fee?stationCode=' + stationCode + '&carNumber=' + carNumber
    });
};

export const payParkFee = (stationCode, carNumber, orderNo, freeTime, useBalance, orderSns) => {
    return axios.request({
        method: 'POST',
        data: orderSns,
        url: 'storage/car/pay/park-fee?stationCode=' + stationCode + '&carNumber=' + carNumber
            + '&orderNo=' + orderNo + '&useBalance=' + useBalance + "&freeTime=" + freeTime
    });
};

export const getJsApiConfigParams = (url) => {
    return axios.request({
        method: 'POST',
        data: url,
        url: 'storage/wx/jsApiConfigParams'
    });
};

export const getUploadPrivateParams = (params) => {
    return axios.request({
        method: 'GET',
        url: 'storage/file/uploadPrivateParams',
        params: params
    });
};

export const deleteUploadFile = (params) => {
    return axios.request({
        method: 'DELETE',
        url: 'storage/file',
        params: params
    });
};